import React from "react";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { NavLink } from "react-router-dom";
import "./DiscussionPanelists.css";

const panelistsData = [
  {
    id: "james-borley",
    name: "Mr. James Borley",
    designation: "Director Payment Services",
    image: "assets/images/discussion-panalist/MR.-James-Borley.png",
    companyLogo: "assets/images/discussion-panalist/complyport-logo.jpg",
  },
  {
    id: "teresa-cameron",
    name: "Ms. Teresa Cameron",
    designation: "Group CEO ",
    image: "assets/images/discussion-panalist/MS.-Teresa-Cameron.png",
    companyLogo: "assets/images/discussion-panalist/clear-junction-logo.png",
  },
  {
    id: "oliver-calma",
    name: "Mr. Oliver Calma",
    designation: "Founder & CEO ",
    image: "assets/images/discussion-panalist/Mr.-Oliver-Calma.png",
    companyLogo: "assets/images/discussion-panalist/bc-remit-logo.jpg",
  },
];

const DiscussionPanelists = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, amount: 0.2 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <section className="discussion_panelists_section section_space bg-white">
      <div className="container">
        <div className="heading_block text-center mb-5" ref={sectionRef}>
          <motion.div
            className="badge style_2 text-uppercase mb-2"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.5 }}
          >
            <i className="fa-solid fa-circle text-primary"></i> OUR PANELISTS <i className="fa-solid fa-circle text-primary"></i>
          </motion.div>
          <motion.h2
            className="heading_text mb-0 fw-bold"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Discussion Panelists
          </motion.h2>
        </div>

        <motion.div
          className="row g-4 justify-content-center"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {panelistsData.map((panelist) => (
            <motion.div
              key={panelist.id}
              className="col-lg-4 col-md-6"
              variants={itemVariants}
            >
              <div className="card border-0 p-4 rounded-4 h-100 text-center panelist_card_new">
                <div className="card_img_container position-relative p-2">
                  {/* Orange Corner Accents */}
                  <div className="corner_accent top_left"></div>
                  <div className="corner_accent bottom_right"></div>
                  
                  <img
                    src={panelist.image}
                    alt={panelist.name}
                    className="img-fluid rounded-4 panelist_portrait"
                  />
                </div>
                <div className="card-body px-2 py-4">
                  <h3 className="card-title fw-bold mb-2 h4 text-dark">
                    {panelist.name}
                  </h3>
                  <p className="panelist_designation_text mb-2">
                    {panelist.designation}
                  </p>
                  <div className="company_logo_wrapper mb-3">
                    <img 
                      src={panelist.companyLogo} 
                      alt="Company Logo" 
                      className="company_logo img-fluid" 
                    />
                  </div>
                  <NavLink 
                    to={`/discussion-panel-2026#${panelist.id}`} 
                    className="btn btn_brand_orange rounded-pill w-100 py-3 fw-bold"
                  >
                    Learn More
                  </NavLink>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default DiscussionPanelists;
